:root {
	--pin-shadow-hover-scale: 0.9;
	--pin-shadow-width: 12px;
	--pin-shadow-height: 5px;
	--pin-shadow-opacity: 0.35;
	--pin-drop-animation-duration-ms: 250ms;
}

@keyframes drop-pin {
	0% {
		transform: translateY(-200%);
	}

	100% {
		transform: translateY(0);
	}
}

@keyframes pin-shadow {
	0% {
		transform: scale(var(--pin-shadow-hover-scale));
	}

	100% {
		transform: scale(1);
	}
}

.mappedin-dropped-pin-wrapper {
	position: relative;

	width: fit-content;
	height: fit-content;
	width: 36px;
	height: 42px;

	& svg {
		position: absolute;
		left: calc(50% - var(--pin-shadow-width));
		animation: drop-pin var(--pin-drop-animation-duration-ms) ease-in;
	}

	& > .pin-shadow {
		position: absolute;
		left: calc(50% - (var(--pin-shadow-width) / 2));
		bottom: 0;

		height: var(--pin-shadow-height);
		width: var(--pin-shadow-width);
		border-radius: 100%;

		opacity: var(--pin-shadow-opacity);

		animation: pin-shadow 250ms ease-in;
	}
}

@keyframes bounce {
	0% {
		transform: translateY(-10px);
		opacity: 0;
	}
	12.5% {
		transform: translateY(0);
		opacity: 1;
	}
	25% {
		transform: translateY(0);
	}
	37.5% {
		transform: translateY(-10px);
	}
	50% {
		transform: translateY(0);
	}
	62.5% {
		transform: translateY(-10px);
	}
	75% {
		transform: translateY(0);
	}
	87.5% {
		transform: translateY(-10px);
	}
	100% {
		transform: translateY(0);
	}
}

.mappedin-connection-marker {
	position: relative;
	display: flex;

	.bouncey {
		animation: bounce 2.5s linear;
	}

	.arrow--down {
		transform: rotate(180deg);
	}

	.connection-circle {
		display: flex;
		box-sizing: border-box;
		justify-content: center;
		align-items: center;
		border-radius: 50%;
		border: 2px solid white;
		box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
		background: #595959;
	}
}
